import React, { useState } from "react";
import {Button, Col, Row, Space, Table} from "antd";

import { CSVLink } from "react-csv";

import dayjs from "dayjs";
import Search from "antd/es/input/Search";

// 1. Niveau Master : Propriétaire
const masterColumns = [
  { title: "Code Propriétaire", dataIndex: "code", key: "code", width: "20%" },
  { title: "Propriétaire", dataIndex: "owner", key: "owner", width: "50%" },
  {
    title: "Montant Total",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    render: (amount) => parseFloat(amount).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })
  },
];

// 2. Niveau Sous-Master : Journal
const journalColumns = [
  { title: "Code Journal", dataIndex: "journal", key: "journal", width: "70%" },
  {
    title: "Sous-total Journal",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    render: (amount) => parseFloat(amount).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })
  },
];

// 3. Niveau Détail : Lignes de dépenses
const detailColumns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (date) => dayjs(date).format("DD/MM/YYYY")
  },
  { title: "Libellé", dataIndex: "libelle", key: "libelle" },
  {
    title: "Montant",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    render: (amount) => parseFloat(amount).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })
  },
];

const csvHeaders = [
  { label: "Code Journal", key: "journal" },
  { label: "Code Propriétaire", key: "code" },
  { label: "Propriétaire", key: "owner" },
  { label: "Total", key: "formattedAmount" },
];

const ListDepenses = ({expenses, loading}) => {
  const [searchText, setSearchText] = useState('');

  const csvData = expenses.reduce((acc, current) => {
    const key = `${current.journal}-${current.code}`;
    let entry = acc.find((item) => item.key === key);
    if (!entry) {
      entry = {
        key,
        journal: current.journal,
        code: current.code,
        owner: current.owner,
        amount: 0,
      };
      acc.push(entry);
    }
    entry.amount += parseFloat(current.amount);
    // pour le formatage du montant dans le CSV -> Microsoft, sinon amount suffit amplement
    entry.formattedAmount = entry.amount.toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return acc;
  }, []);

  const groupedData = expenses.reduce((acc, current) => {
    // Trouver ou créer le Propriétaire (Master)
    let owner = acc.find(item => item.code === current.code);
    if (!owner) {
      owner = {
        ...current,
        key: current.code,
        amount: 0,
        journals: [] // Nouveau niveau
      };
      acc.push(owner);
    }
    owner.amount += parseFloat(current.amount);

    // Trouver ou créer le Journal (Sous-Master) à l'intérieur du Propriétaire
    let journal = owner.journals.find(j => j.journal === current.journal);
    if (!journal) {
      journal = {
        journal: current.journal,
        key: `${owner.code}-${current.journal}`,
        amount: 0,
        details: []
      };
      owner.journals.push(journal);
    }
    journal.amount += parseFloat(current.amount);
    journal.details.push({
      ...current ,
      detailKey: `${journal.key}-${journal.details.length}`
    });

    return acc;
  }, []);

  // Filtrage des données basé sur searchText
  const filteredData = groupedData.filter(item => {
    const search = searchText.toLowerCase();
    return (
      (item.code && item.code.toLowerCase().includes(search)) ||
      (item.owner && item.owner.toLowerCase().includes(search))
    );
  });

  const handleChange = (e) => {
    setSearchText(e.target.value);
  }
  return (
    <div style={{ padding: 20 }}>
      <Row gutter={12} style={{ marginTop: 10 }}>
        <Col span={24}>
          <Space size={"middle"} direction={"vertical"} style={{width:'100%'}}>
            <Row justify="space-between" align="middle">
              <Col>
                <Search placeholder="Rechercher propriétaire ou code..." allowClear onChange={handleChange} style={{ width: 300 }} />
              </Col>
              <Col>
                {expenses && (
                  <Space size={"small"} direction={"horizontal"}>
                    <Button>
                      <CSVLink
                        filename={"export.csv"}
                        headers={csvHeaders}
                        data={csvData}
                        separator={";"}
                      >
                        Export CSV
                      </CSVLink>
                    </Button>
                    <Button>
                      <CSVLink
                        filename={"export.csv"}
                        data={expenses}
                        separator={";"}
                      >
                        Export CSV général
                      </CSVLink>
                    </Button>
                  </Space>
                )}
              </Col>
            </Row>
            <Table
              loading={loading}
              dataSource={filteredData}
              columns={masterColumns}
              pagination={false}
              rowKey="key"
              expandable={{
                expandedRowRender: (ownerRecord) => (
                  <Table
                    columns={journalColumns}
                    dataSource={ownerRecord.journals}
                    pagination={false}
                    size="small"
                    rowKey="key"
                    expandable={{
                      // Second niveau d'expansion pour les détails du journal
                      expandedRowRender: (journalRecord) => (
                        <Table
                          columns={detailColumns}
                          dataSource={journalRecord.details}
                          pagination={false}
                          size="small"
                          rowKey="detailKey"
                        />
                      ),
                      rowExpandable: (record) => record.details.length > 0,
                    }}
                  />
                ),
                rowExpandable: (record) => record.journals.length > 0,
              }}
            />
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default ListDepenses;
